export default __webpack_public_path__ + "static/media/digitalH.d0958524.png";